import { ONBOARDING_VIEWS } from 'user-context/onboardingSettings';
import { ONBOARDING_FREE_SERVICE } from 'getting-started-shared-tasks/onboardingKeys';
import { FREE_GROUP_KEYS } from 'getting-started-shared-tasks/gettingStartedGroupKeys';
import { HubletUrl } from '../utils/urls';
import { SERVICE_SIGNUP } from '../constants/signupConstants';
import { ONBU025_EXPERIMENT_KEY, ONBU025_VARIANT_GROUP } from '../constants/experimentConstants';
const servicesExperiencesChecks = [{
  // Note: ONBU025 variant users see the same experience except with the variant groupkeys
  // The only change in these groupkeys is that the 'create contact' and 'create deal' tasks go to the corresponding wizard instead of a tour
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
      view: ONBOARDING_VIEWS.SERVICE,
      onboardingKey: ONBOARDING_FREE_SERVICE,
      groupKey: FREE_GROUP_KEYS.freeServiceViewWizard
    };
  },
  checks: [{
    signupExperimentTreatments: {
      [ONBU025_EXPERIMENT_KEY]: ONBU025_VARIANT_GROUP
    },
    signupType: SERVICE_SIGNUP
  }]
}, {
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
      view: ONBOARDING_VIEWS.SERVICE,
      onboardingKey: ONBOARDING_FREE_SERVICE,
      groupKey: FREE_GROUP_KEYS.freeServiceView
    };
  },
  checks: [{
    signupType: SERVICE_SIGNUP
  }]
}];
export default servicesExperiencesChecks;